import styled from 'styled-components';
import { Container as ContainerBoxGrid } from '@/main/components/shared/boxGrid/styles';

interface ITextValue {
  cursor: 'default' | 'pointer';
  textUnderline?: boolean;
}

export const TextValue = styled.span<ITextValue>`
  display: block;
  text-align: center;
  text-decoration: ${props => (props.textUnderline ? 'underline' : 'default')};
  ${props =>
    props.cursor === 'default' &&
    `
    cursor: default;
    `}
  ${props =>
    props.cursor === 'pointer' &&
    `
    cursor: pointer;
    `}
`;

export const ContainerCategory = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  background-color: white;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: bold;
  border: 1px solid rgba(224, 224, 224, 1);
  align-items: center;
`;
export const BoxCategoryName = styled.div`
  text-align: left;
`;
export const BoxCategoryActions = styled.div`
  text-align: right;
`;

export const ContainerGrid = styled.div`
  > ${ContainerBoxGrid} {
    margin: 0;
  }
`;

export const ContainerLabel = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LabelItem = styled.div`
  margin: 0 0.4rem 0 0;
`;

export const CollumnName = styled.div`
  word-break: break-word;
`;

export const LabelResult = styled.div``;

